import { render } from "./tab-button.vue?vue&type=template&id=0ed8f128&scoped=true&lang=true"
import script from "./tab-button.vue?vue&type=script&lang=js"
export * from "./tab-button.vue?vue&type=script&lang=js"

import "./tab-button.vue?vue&type=style&index=0&id=0ed8f128&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed8f128"]])

export default __exports__